import React from 'react'
import './modal.css'

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.click = this.click.bind(this);
  }

  click(alt) {
    this.props.clickOnModal(alt);
  }

  render() {
    const { alt, src, display, clickOnModal } = this.props;
    return (
      <div id="myModal" className="modal" style={{ display: (display == true) ? "block" : "none" }} onClick={e => this.click(alt)}>
        <span className="close">×</span>
        <img className="modal-content" id="img01" src={src} />
        <div id="caption">{alt}</div>
      </div>
    )
  }
}

export default Modal


// WEBPACK FOOTER //
// ./src/components/gallery/Modal.jsx